import React from 'react'
import {
  ButtonGroup,
  ContextNotification,
  Paragraph,
  TextInput,
} from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'
import { Field, FieldProps, useFormikContext } from 'formik'

import { FormValues } from '../../../TerminateForm/initialValues'

import FormFieldWrapper from 'components/FormField'

export const RightOfOccupancyPaymentHeader: React.FC = () => {
  const { values: formValues } = useFormikContext<FormValues>()
  const showCollateralBankInstructions = !formValues.isCollateral
  const { t } = useTranslation(['terminateContract'])
  const endDate = formValues.firstPossibleEndDate.toFormat('dd.MM.yyyy')

  const isPropertyCompanyAddressValid =
    formValues.propertyCompanyName !== null &&
    formValues.propertyCompanyAddress !== null

  return (
    <>
      <Paragraph className="mb-6 leading-6" large>
        {t('terminateContract:texts.paymentInfoReason')}
      </Paragraph>
      <Field name="isCollateral">
        {({ field, meta, form }: FieldProps<FormValues['isCollateral']>) => {
          return (
            <FormFieldWrapper
              name={field.name}
              label={t(
                'terminateContract:labels.rightOfOccupancyCollateralLocation'
              )}
              className="min-tablet:flex-1 mb-6"
              meta={meta}
              labelBold
              required
            >
              <ButtonGroup
                id="isCollateral"
                onChange={(suggestionId) =>
                  form.setFieldValue('isCollateral', suggestionId === '2')
                }
                suggestions={[
                  {
                    id: '1',
                    label: t(
                      'terminateContract:rightOfOccupancyCollateralLocationSuggestions.holder'
                    ),
                  },
                  {
                    id: '2',
                    label: t(
                      'terminateContract:rightOfOccupancyCollateralLocationSuggestions.bank'
                    ),
                  },
                ]}
                value={
                  formValues.isCollateral !== null
                    ? formValues.isCollateral
                      ? '2'
                      : '1'
                    : undefined
                }
                fullwidth
                className="font-medium mb-6"
              />
            </FormFieldWrapper>
          )
        }}
      </Field>

      {formValues.isCollateral && (
        <Field name="collateralLender">
          {({ field, meta }: FieldProps<FormValues['collateralLender']>) => (
            <FormFieldWrapper
              name={field.name}
              label={t('terminateContract:labels.bank')}
              className="min-tablet:flex-1 mb-6"
              meta={meta}
              labelBold
              required
            >
              <TextInput {...field} />
            </FormFieldWrapper>
          )}
        </Field>
      )}

      {showCollateralBankInstructions && isPropertyCompanyAddressValid && (
        <Paragraph className="whitespace-pre-line text-lg mb-6 leading-6" large>
          {t('terminateContract:texts.paymentInfoCollateralBankInstructions', {
            companyName: formValues.propertyCompanyName,
            companyAddress: formValues.propertyCompanyAddress,
            endDate,
          })}
        </Paragraph>
      )}
      {showCollateralBankInstructions && !isPropertyCompanyAddressValid && (
        <Paragraph className="whitespace-pre-line text-lg mb-6 leading-6" large>
          {t(
            'terminateContract:texts.paymentInfoCollateralBankInstructionsNoAddress',
            {
              endDate,
            }
          )}
        </Paragraph>
      )}
      {showCollateralBankInstructions && !isPropertyCompanyAddressValid && (
        <ContextNotification type="error" className="mb-6">
          {t('terminateContract:texts.propertyCompanyAddressError')}
        </ContextNotification>
      )}
    </>
  )
}
